import { Progress, Stack, Text } from "@mantine/core"
import { primaryColor } from '../../../constants/theme';

export const ProgressBar = ({step, total, progressTestId, textTestId}: {step: number, total: number, progressTestId: string, textTestId: string}) => {

    return (
            <Stack align='start' w={'100%'}>
                <Text c='dimmed' fw='bold' pl='md' data-testid={textTestId}>Step {step}/{total}</Text>
                <Progress w={'100%'} size='md' value={(step / total) * 100} color={primaryColor} data-testid={progressTestId}></Progress>
            </Stack>
    )
}